import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { Logo } from "@/components/Logo";
import { SourcesTable } from "@/components/SourcesTable";
import { PROFILES } from "@/lib/legal";

const lk = "block hover:text-[#00f2a1] transition-colors";

export const Footer = () => (
  <footer className="bg-[#0a1f18] text-slate-400 border-t border-[#1b3d30]" data-testid="site-footer">
    <div className="max-w-[1400px] mx-auto px-5 lg:px-8 py-14 grid gap-10 md:grid-cols-5">
      <div className="md:col-span-2 space-y-4">
        <Logo testId="footer-logo" />
        <p className="max-w-sm text-sm leading-relaxed">Motor de simbiosis industrial para valorizar mermas, descartes técnicos y scrap industrial en Chile.</p>
      </div>
      <div className="space-y-2 text-sm" data-testid="footer-about">
        <p className="text-white font-semibold mb-3">Lo que somos</p>
        <Link className={lk} to="/nosotros" data-testid="footer-about-link">Propósito, Misión y Visión</Link>
        <Link className={lk} to="/nosotros#manifiesto" data-testid="footer-about-manifesto">Manifiesto de Simbiosis Industrial</Link>
        <Link className={lk} to="/contacto" data-testid="footer-contact-link">Contáctanos</Link>
        <a className={`${lk} inline-flex items-center gap-1.5`} href="https://www.instagram.com/terraloop.cl/" target="_blank" rel="noreferrer" data-testid="footer-instagram-link"><Instagram className="w-4 h-4" />Instagram</a>
      </div>
      <div className="space-y-2 text-sm">
        <p className="text-white font-semibold mb-3">Plataforma</p>
        <Link className={lk} to="/marketplace" data-testid="footer-link-marketplace">Marketplace</Link>
        <Link className={lk} to="/publicar" data-testid="footer-link-publish">Publicar Lote</Link>
        <Link className={lk} to="/calculadora" data-testid="footer-link-calculator">Calculadora ESG</Link>
      </div>
      <div className="space-y-2 text-sm" data-testid="footer-profiles">
        <p className="text-white font-semibold mb-3">Perfiles</p>
        {Object.entries(PROFILES).map(([slug, p]) => (
          <Link key={slug} className={lk} to={`/perfiles/${slug}`} data-testid={`footer-profile-${slug}`}>{p.nav}</Link>
        ))}
      </div>
    </div>
    <div className="max-w-[1400px] mx-auto px-5 lg:px-8 pb-14" data-testid="footer-sources">
      <p className="text-white font-semibold mb-4 text-sm">Fuentes Oficiales</p>
      <SourcesTable testid="footer-sources-table" />
    </div>
    <div className="border-t border-[#1b3d30] py-5 text-center text-xs font-mono">© 2026 terraloop.cl · Economía circular industrial</div>
  </footer>
);
